/* RESPONSIBLE TEAM: team-automation-foundations */
export const contentWrapperTypes = {
  answers: 4,
};
